import LecturePrototypeModuleListPagingResultModelBase from '../_generated/modelBases/lecture-prototype-module-list-paging-result-model-base';

export default class LecturePrototypeModuleListPagingResultModel extends LecturePrototypeModuleListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
